import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, typePrefix } from '~lookups/actions/serviceBranches';

import { Lookup } from '../models';

const initialState: CommonState<Lookup> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  row: undefined,
};

const slice = buildSlice<CommonState<Lookup>, Lookup>(typePrefix, initialState, {
  commonConfig: { getAll },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
